export default __webpack_public_path__ + "static/checknlearn-promo-small@2x-47142a513fa247e1b7d33160a4df1aaa.jpg";